export enum PaneType {
  Filters = 'filters',
  LayoutSettings = 'layoutSettings',
  OrderEntry = 'orderEntry',
  AllocationCreate = 'allocationCreate',
  BondPreview = 'bondPreview',
  ModelPreview = 'modelPreview',
  ProposalOrderDetails = 'proposalOrderDetails',
  ReviewProposals = 'reviewProposals',
  RuleCondition = 'RuleCondition',
  ExecutionRuleExecution = 'ExecutionRuleExecution',
  InquiryPricingRule = 'InquiryPricingRule',
  UnmatchedExecutions = 'unmatchedExecutions',
}
